export const getUserModules = () => {
    const cookies = document.cookie.split('; ');
    const perfilCookie = cookies.find(c => c.startsWith('perfil='));
    const perfil = perfilCookie ? decodeURIComponent(perfilCookie.split('=')[1]) : '';
    if (perfil === 'Super-Admin') return null; // null = acceso total
    const modulesCookie = cookies.find(c => c.startsWith('modules='));
    if (!modulesCookie) return [];
    // El cookie viene URL-encodeado (las comas son %2C); decodificar antes de separar.
    return decodeURIComponent(modulesCookie.split('=')[1]).split(',').map(s => s.trim()).filter(Boolean);
};

export const canAccess = (moduleKey) => {
    const modules = getUserModules();
    return modules === null || modules.includes(moduleKey);
};

/** True solo si el perfil del usuario es Super-Admin (config SaaS: precios, paquetes). */
export const isSuperAdmin = () => {
    const cookies = document.cookie.split('; ');
    const perfilCookie = cookies.find(c => c.startsWith('perfil='));
    const perfil = perfilCookie ? decodeURIComponent(perfilCookie.split('=')[1]) : '';
    return perfil === 'Super-Admin';
};
